import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

// 260625: AI 생성 유료화 — flag off면 준비중 모달 + 차단(rule 55, fail-closed). 딥링크/뒤로가기 우회 차단.
const requireAiGenFlag = async (to, from) => {
  await store.dispatch('common/fetchFeatureFlags', { force: true });
  const flags = store.getters['common/getFeatureFlags'];
  if (!flags?.aiCreativeGenerateEnabled) {
    showTextModal('AI 생성 기능은 현재 준비중이에요.\n곧 만나뵐게요.', '확인');
    return from?.name ? false : '/intro';
  }
};

export default [
  {
    path: '/card/my',
    component: () => import('@/views/card/MyCards.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '명함'
    }
  },
  {
    path: '/card/register',
    component: () => import('@/views/card/CardRegister.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '명함 등록'
    }
  },
  {
    path: '/card/edit/:cardNo',
    component: () => import('@/views/card/CardRegister.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '명함 수정'
    }
  },
  {
    path: '/card/detail/:cardNo',
    component: () => import('@/views/card/CardDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '명함 상세'
    }
  },
  {
    path: '/card/received',
    component: () => import('@/views/card/ReceivedCards.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '받은 명함함'
    }
  },
  {
    path: '/card/share/:cardNo',
    component: () => import('@/views/card/CardShare.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '명함'
    }
  },
  {
    path: '/card/custom',
    component: () => import('@/views/card/CardCustom.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'AI 명함 만들기'
    },
    beforeEnter: async (to, from) => {
      const blocked = await requireAiGenFlag(to, from);
      if (blocked !== undefined) return blocked;
    }
  }
];
